/** Тип уведомления. */
export enum TemplateNotificationType {
    /** Текст смс-оповещения. */
    SmsGeneral = "sms-general"
}
